// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"23c19b7c","410":"81233984","577":"367b2b3d","867":"bd11feb6","988":"c2dd2f5d"}[chunkId] + ".chunk.js";
};